import { cn } from "@/app/views/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";

export const inputClasses =
  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring md:text-sm";

export const inputDisabledClasses =
  "disabled:cursor-not-allowed disabled:opacity-50";

const Input = ({
  className,
  type,
  icon,
  ...props
}: ComponentProps<"input"> & { icon?: LucideIcon }) => {
  if (icon) {
    const Icon = icon;
    return (
      <div className="relative w-full">
        <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
          <Icon className="w-4 h-4 text-muted-foreground" />
        </div>
        <input
          type={type}
          className={cn(inputClasses, inputDisabledClasses, "pl-7", className)}
          {...props}
        />
      </div>
    );
  }
  return (
    <input
      type={type}
      className={cn(inputClasses, inputDisabledClasses, className)}
      {...props}
    />
  );
};

Input.displayName = "Input";

export { Input };
